import BaseImage from 'next/image';

export const Image = ({
  className,
  blurWidth: _blurWidth,
  blurHeight: _blurHeight,
  ...props
}: React.ComponentProps<typeof BaseImage> & { blurWidth?: number; blurHeight?: number }) => (
  <div className={className}>
    <BaseImage {...props} loader={({ src }) => src} unoptimized />
  </div>
);
